/* Doors of Goree - shared front-end behavior.
   Defensive: every block checks for its elements so any page can load this file.
   In the Shopify theme, the cart/newsletter hooks are replaced by Shopify's
   real product forms and customer/marketing integrations. */
(function(){
  "use strict";

  // ---- mobile nav ----
  var hb = document.getElementById('hb'),
      links = document.getElementById('navlinks');
  if(hb && links){
    hb.addEventListener('click', function(){
      var open = links.classList.toggle('open');
      hb.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    links.addEventListener('click', function(e){
      if(e.target.tagName === 'A'){
        links.classList.remove('open');
        hb.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ---- light / dark theme toggle ----
  // The initial theme is applied by an inline script in the <head> (no flash).
  // Default is dark; the visitor's choice is remembered in localStorage.
  var themeBtn = document.getElementById('themeToggle');
  if(themeBtn){
    themeBtn.addEventListener('click', function(){
      var root = document.documentElement;
      var next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
      if(next === 'light'){ root.setAttribute('data-theme', 'light'); }
      else { root.removeAttribute('data-theme'); }
      try{ localStorage.setItem('dog-theme', next); }catch(e){}
      themeBtn.setAttribute('aria-pressed', next === 'light' ? 'true' : 'false');
    });
  }

  // ---- scroll reveals ----
  var els = document.querySelectorAll('.reveal');
  if(els.length){
    if('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, {threshold:.14, rootMargin:'0px 0px -8% 0px'});
      els.forEach(function(el){ io.observe(el); });
    } else {
      els.forEach(function(el){ el.classList.add('in'); });
    }
  }

  // ---- newsletter (front-end only) ----
  var f = document.getElementById('newsForm'),
      m = document.getElementById('newsMsg');
  if(f && m){
    f.addEventListener('submit', function(e){
      e.preventDefault();
      var v = f.email.value.trim();
      if(!v || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){
        m.style.color = 'var(--oxblood)';
        m.textContent = 'Please enter a valid email address.';
        return;
      }
      m.style.color = 'var(--teal)';
      m.textContent = 'Thank you — welcome to the community.';
      f.reset();
    });
  }

  // ---- product / add-to-cart buttons (placeholder) ----
  document.querySelectorAll('[data-product]').forEach(function(b){
    b.addEventListener('click', function(e){
      e.preventDefault();
      var label = b.textContent;
      b.textContent = 'Added ✓';
      setTimeout(function(){ b.textContent = label; }, 1400);
    });
  });

  // ---- category filter (collection page) ----
  var tabs = document.querySelectorAll('.cat-tab');
  if(tabs.length){
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var cat = tab.getAttribute('data-cat');
        tabs.forEach(function(t){ t.classList.toggle('active', t === tab); });
        document.querySelectorAll('[data-category]').forEach(function(card){
          var show = (cat === 'all' || card.getAttribute('data-category') === cat);
          card.style.display = show ? '' : 'none';
        });
      });
    });
  }

  // ---- painted Goree door grids (home + collection tiles) ----
  var NS = 'http://www.w3.org/2000/svg';
  var PALETTE = ['#c9772a','#2f7d76','#a83f2a','#3f5c8a','#d9a531','#7a8a3a','#8a4a7a','#b8632c','#356b6a','#9a5a3a','#4a7a8a','#c78a2a'];

  document.querySelectorAll('[data-doors]').forEach(function(svg){
    paintDoors(svg, parseInt(svg.getAttribute('data-doors'), 10));
  });

  function paintDoors(svg, n){
    if(!svg || !n) return;
    var W = 320, H = 400;
    var wall = document.createElementNS(NS, 'rect');
    wall.setAttribute('width', W); wall.setAttribute('height', H); wall.setAttribute('fill', '#d8cbb0');
    svg.appendChild(wall);
    var gap = W / n, dw = gap * 0.66, dh = (H / n) * 0.72, pad = gap * 0.17;
    for(var r = 0; r < n; r++){
      for(var c = 0; c < n; c++){
        var x = c * gap + pad,
            y = r * (H / n) + ((H / n) - dh) / 2,
            col = PALETTE[(r * n + c) % PALETTE.length];
        drawDoor(svg, x, y, dw, dh, col);
      }
    }
  }

  function drawDoor(svg, x, y, w, h, col){
    var g = document.createElementNS(NS, 'g');
    var frame = document.createElementNS(NS, 'rect');
    frame.setAttribute('x', x - 2); frame.setAttribute('y', y - 2);
    frame.setAttribute('width', w + 4); frame.setAttribute('height', h + 4);
    frame.setAttribute('fill', 'rgba(0,0,0,.28)'); frame.setAttribute('rx', 2);
    var slab = document.createElementNS(NS, 'rect');
    slab.setAttribute('x', x); slab.setAttribute('y', y);
    slab.setAttribute('width', w); slab.setAttribute('height', h);
    slab.setAttribute('fill', col); slab.setAttribute('rx', 1.5);
    g.appendChild(frame); g.appendChild(slab);
    var seam = document.createElementNS(NS, 'line');
    seam.setAttribute('x1', x + w / 2); seam.setAttribute('y1', y);
    seam.setAttribute('x2', x + w / 2); seam.setAttribute('y2', y + h);
    seam.setAttribute('stroke', 'rgba(0,0,0,.35)'); seam.setAttribute('stroke-width', 1);
    g.appendChild(seam);
    var pw = w * 0.32, ph = h * 0.34;
    [[0.09,0.08],[0.59,0.08],[0.09,0.55],[0.59,0.55]].forEach(function(p){
      var pr = document.createElementNS(NS, 'rect');
      pr.setAttribute('x', x + w * p[0]); pr.setAttribute('y', y + h * p[1]);
      pr.setAttribute('width', pw); pr.setAttribute('height', ph);
      pr.setAttribute('fill', 'rgba(0,0,0,.16)'); pr.setAttribute('stroke', 'rgba(255,255,255,.14)');
      pr.setAttribute('stroke-width', .8); pr.setAttribute('rx', 1);
      g.appendChild(pr);
    });
    svg.appendChild(g);
  }
})();
